import React from 'react';
import PropTypes from 'prop-types';
import Toast from "../../../../components/WMS/Toast";
import {FormattedMessage} from "react-intl";
import RedWarning from "assets/img/redWarning.svg"

NoRetrievedTaskToast.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

function NoRetrievedTaskToast({open, handleClose}) {
    return (
        <Toast
            open={open}
            handleClose={handleClose}
            icon={
                <img
                    src={RedWarning}
                    alt={"warning"}
                    style={{
                        width: '20px',
                        height: '20px',
                    }}
                />
            }
            title={<FormattedMessage id={"wms.myPickingMissions.selfAffectationMission.noMissionFound.title"}/>}
            subtitle={<FormattedMessage id={"wms.myPickingMissions.selfAffectationMission.noMissionFound.subtitle"}/>}
        />
    );
}

export default NoRetrievedTaskToast;